import React, { useState } from 'react'
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const FotgotPasswordForm = ({ user, showInfo, product }) => {

    const history = useHistory();


    return (
        <Formik
            initialValues={{
                pin: '',
            }}
            validate={values => {
                const errors = {};
                if (!values.email) {
                    errors.email = 'Email is Required';
                } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                    errors.email = 'Invalid email address';
                }
                return errors;
            }}
            onSubmit={async (values, { setSubmitting, setErrors }) => {

                setSubmitting(true);

                const res = await axios.post('https://evalexpert.io/v1/forgotpass', { email: values.email, product })
                const data = res.data;
                setSubmitting(false);

                if (data.success === "Recovery Email Sent") {
                    history.push('/insightsdashboard/pages/dashboard/signin');
                    showInfo('Password reset email sent!');
                } else if (data.error) {
                    setErrors({email: data.error});
                }

            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
            }) => (
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                            Email address
                        </label>
                        <div className="mt-1">
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                placeholder="Email Address"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                className={
                                    errors.email && touched.email ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                        : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                }
                            />
                            <p className="text-sm text-red-600" id="email-error">
                                {errors.email && touched.email && errors.email}
                            </p>
                        </div>
                    </div>
                    <div>
                        <button
                            type="submit"
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                            disabled={isSubmitting}
                        >
                            Send
                        </button>

                        <p className="mt-2 text-sm text-gray-700">
                            Back to <p className="cursor-pointer text-sm text-gray-800 inline font-medium" onClick={() => history.push('/insightsdashboard/pages/dashboard/signin')}>Sign In</p>
                        </p>
                    </div>
                </form>
            )}
        </Formik>
    )
}

export default FotgotPasswordForm;
